$(window).on("load resize orientationchange",function(e){
    preview();
});

function preview() {
    $(".js-preview").each(function() {
         $(this).find("p").html($(this).siblings(".js-previewFull").html());
         var $title = $(this).find("p");
         while ($title.height() > $(this).height()) {
         $title.text($title.text().split(" ").slice(0, $title.text().split(" ").length - 1).join(" ")); // + "...");
      }
    });
}
